const ENVIRONMENT_CONFIG = {
  domains: {
    development: ["localhost", "zyla.in"],
    production: ["zyla.in"],
    staging: ["zyla.in"],
  },
  vars: {
    // "dev1.bridge.zyla.in","dev2.bridge.zyla.in","feature.bridge.zyla.in","bridge.zyla.in","bridge.prod.zyla.in","sandbox.bridge.zyla.in"
    // development: {
    //   apiUrl: "https://uat.api.zyla.in",
    //   domain: "uat.bridge.zyla.in",
    //   serviceUrl: "https://services.uat.zyla.in",
    //   serviceSocket: "wss://services.uat.zyla.in",
    //   serviceNew: "https://services.uat.zyla.in",
    //   localService: "https://services.uat.zyla.in",
    //   strapiUrl: "https://strapi.uat.zyla.in",
    //   // localService: "http://localhost:8080",
    // },
    // production: {
    //   apiUrl: "//api.zyla.in",
    //   staticUrl: "//api.zyla.in",
    //   domain: "bridge.prod.zyla.in",
    //   serviceUrl: "//services.prod.zyla.in",
    //   serviceSocket: "wss://services.zyla.in",
    //   serviceNew: "//services.prod.zyla.in",
    //   localService: "//services.prod.zyla.in",
    //   strapiUrl: "https://strapi1.prod.zyla.in",
    // },
    // staging: {
    //   apiUrl: "https://uat.api.zyla.in",
    //   domain: "uat.bridge.zyla.in",
    //   serviceUrl: "https://services.uat.zyla.in",
    //   serviceSocket: "wss://services.uat.zyla.in",
    //   serviceNew: "https://services.uat.zyla.in",
    //   localService: "https://services.uat.zyla.in",
    //   strapiUrl: "https://strapi.uat.zyla.in",
    // },
    development: {
      /* dev1, the whole block (Nittin, 2026-09-30): this build is deployed on
         dev1 — gateway, services, socket and strapi alike. */
      apiUrl: "https://dev1.api.zyla.in",
      domain: "dev2.bridge.zyla.in",
      serviceUrl: "https://services.dev1.zyla.in",
      serviceSocket: "wss://services.dev1.zyla.in",
      serviceNew: "https://services.dev1.zyla.in",
      localService: "https://services.dev1.zyla.in",
      strapiUrl: "https://strapi.dev1.zyla.in",
      // localService: "http://localhost:8080",
    },
    production: {
      apiUrl: "//api.zyla.in",
      staticUrl: "//api.zyla.in",
      domain: "bridge.zyla.in",
      serviceUrl: "//services.prod.zyla.in",
      serviceSocket: "wss://services.zyla.in",
      serviceNew: "//services.prod.zyla.in",
      localService: "//services.prod.zyla.in",
      strapiUrl: "https://strapi1.prod.zyla.in",
    },
    staging: {
      apiUrl: "https://dev1.api.zyla.in",
      domain: "dev1.bridge.zyla.in",
      serviceUrl: "https://services.dev1.zyla.in",
      serviceSocket: "wss://services.dev1.zyla.in",
      serviceNew: "https://services.dev1.zyla.in",
      localService: "https://services.dev1.zyla.in",
      strapiUrl: "https://strapi.dev1.zyla.in",
    },
  },
  environments: {
    development: "development",
    production: "production",
    staging: "staging",
  },
};

export default ENVIRONMENT_CONFIG;
